import { DayPortion } from '../types/time-off-request';
import { DURATION_LABEL_KEY } from './time-off-duration-labels';

/** All selectable day portions, in display order, for the create-mode duration select. */
export const DAY_PORTION_ORDER: DayPortion[] = [
  DayPortion.Full,
  DayPortion.Half,
  DayPortion.Quarter,
  DayPortion.Hourly,
];

/**
 * The `dayPartNumber` choices for a HALF / QUARTER day, paired with their i18n
 * label key. `dayPartNumber` is what the backend expects (1-based); the
 * response-side `partOfDay` enum is derived from it.
 */
export const HALF_DAY_PART_OPTIONS: { value: number; labelKey: string }[] = [
  { value: 1, labelKey: 'partOfDay.firstHalf' },
  { value: 2, labelKey: 'partOfDay.secondHalf' },
];

export const QUARTER_DAY_PART_OPTIONS: { value: number; labelKey: string }[] = [
  { value: 1, labelKey: 'partOfDay.firstQuarter' },
  { value: 2, labelKey: 'partOfDay.secondQuarter' },
  { value: 3, labelKey: 'partOfDay.thirdQuarter' },
  { value: 4, labelKey: 'partOfDay.fourthQuarter' },
];

/** Returns the day-part options for a given portion (empty for FULL / HOURLY). */
export const getDayPartOptions = (portion: DayPortion): { value: number; labelKey: string }[] => {
  if (portion === DayPortion.Half) return HALF_DAY_PART_OPTIONS;
  if (portion === DayPortion.Quarter) return QUARTER_DAY_PART_OPTIONS;
  return [];
};

export { DURATION_LABEL_KEY };
